import axios from '@src/libs/axios'
import { initializeApp } from 'firebase/app'
import { getMessaging, getToken } from 'firebase/messaging'
import { getAnalytics } from 'firebase/analytics'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
    apiKey: 'AIzaSyCuMPEZznntAHOG0I5nwZVb7UDtGOuGLbw',
    authDomain: 'newwise-d79ed.firebaseapp.com',
    projectId: 'newwise-d79ed',
    storageBucket: 'newwise-d79ed.firebasestorage.app',
    messagingSenderId: '207689577307',
    appId: '1:207689577307:web:c10cee5847ec2f13b4e07e',
    measurementId: 'G-CPZV5EPNJQ',
}

const enabled =
    location.hostname === 'localhost' || location.protocol === 'https:'

// Initialize Firebase
const app = firebaseConfig && enabled ? initializeApp(firebaseConfig) : null
const messaging = app && enabled ? getMessaging(app) : null
//const analytics = getAnalytics(app)

export const requestNotificationPermission = async () => {
    if (!enabled) return null
    const permission = await Notification.requestPermission()
    if (!messaging || !app || !firebaseConfig) return
    if (permission === 'granted') {
        const token = await getToken(messaging, {
            vapidKey:
                'BF_Z1Gm4JorFv3fsBwTxst5YTo09GFWbFeT7ftmHH-2WC7l_4xfN7UIvkamn1jAQ4zLNl89AhjZyb90v5YsPSbw',
        })
        axios.post('/api/core/info/firebase', {
            token: token,
        })
        return token
    }
    return null
}

export { messaging }
